'use client';
import React, { useState, useEffect } from 'react';

export const LendingTemplate = ({ lendingCriteria, description }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!lendingCriteria || lendingCriteria.length === 0) return null;

  return (
    <div className="lg:pl-[4.5rem]">
      <h2 className="text-2xl text-[#373945] font-semibold">Lending criteria highlights</h2>
      <p className="text-base text-[#373945] mt-6 font-450 mb-6">
        {description}
      </p>
      <p
        className="lendingCriteria [&_li:last-child]:mb-0"
        dangerouslySetInnerHTML={{ __html: mounted ? lendingCriteria : '' }}
      />
    </div>
  );
};
